.card {
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: var(--radius);
  padding: var(--space-3) var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.risky {
  composes: card;
  border-color: var(--danger);
}

.title {
  font-weight: 600;
}

.header {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--muted);
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.option {
  border: 1px solid var(--border);
  background: var(--surface-2);
  color: var(--text);
  border-radius: var(--radius);
  padding: var(--space-2) var(--space-3);
  cursor: pointer;
  text-align: left;
}

.option:hover,
.option[aria-pressed='true'] {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.optionDescription {
  display: block;
  font-size: 13px;
  color: var(--muted);
}

.check {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
}

.input {
  font: inherit;
  padding: var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  color: var(--text);
}

.actions {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.primary,
.secondary,
.danger {
  border-radius: var(--radius);
  padding: var(--space-2) var(--space-4);
  cursor: pointer;
  border: 1px solid transparent;
}

.primary {
  background: var(--accent);
  color: var(--accent-text);
  font-weight: 700;
}

.secondary {
  background: var(--surface-2);
  color: var(--text);
  border-color: var(--border);
}

.danger {
  background: var(--danger-soft);
  color: var(--danger);
  border-color: var(--danger);
}

.primary:disabled,
.secondary:disabled {
  opacity: 0.5;
  cursor: default;
}

.warning {
  color: var(--danger);
  font-size: 14px;
}

.hint {
  color: var(--muted);
  font-size: 14px;
}

.details pre {
  font-family: var(--mono);
  font-size: 13px;
  background: var(--surface-2);
  border-radius: var(--radius);
  padding: var(--space-2);
  overflow-x: auto;
  max-height: 260px;
}

.closed {
  composes: card;
  color: var(--muted);
  padding: var(--space-2) var(--space-3);
  font-size: 14px;
}

.question {
  border: 0;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
